module.exports = __webpack_public_path__ + "media/images/unpaid2-b3edf7ba206a20a3dbd849b695a97606.png";